export const BOUNDING_BOX_EMPTY = { max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
export const CHAIR_RADIUS_IN_UNITS = 15;
export const DEFAULT_VIEWBOX = {
    max: {
        x: 100,
        y: 100,
    },
    min: {
        x: -100,
        y: -100,
    },
};
export const MAX_ALLOWED_DISTANCE_FOR_TOUCH = 3;
export const MAX_CHAIR_RADIUS_IN_PIXELS = 50;
export const MIN_ANIMATION_DISTANCE = 4;
// We will not allow that the width or height of a viewbox
// becomes larger than the boundingBox size with this factor applied
export const MAX_BOX_FACTOR = 1.5;
export const MAX_ITER_ADJUST = 12;
// maximum view size to allow seat selection on touch devices
// view sizes smaller than this will not provide enough level of detail
// to be able to pick a seat properly
export const MAX_VIEW_SIZE_TOUCH_PAS = 500;
export const MIN_CHAIR_RADIUS_IN_PIXELS = 10;
export const MIN_VIEW_SIZE = 100;
export const VIEWBOX_ANIMATION_TIME = 300;
// To find the difference between pick a seat and panning
// we wait for a few milliseconds before triggering a PAS just in case
export const WAIT_TIME_CONFIRM_TOUCH = 150;
export const ZOOM_FACTOR = 1.0017;
export const ZOOM_BUTTON_FACTOR = 1.15;

// This is a calculated property. It cannot be alpha sorted
export const AUTOZOOM_VIEW_SIZE =
    (MAX_VIEW_SIZE_TOUCH_PAS + MIN_VIEW_SIZE) * 0.5;
